import React from 'react';

export function CellEditor({
  rowKey,
  colKey,
  initialValue,
  updateCell,
  startEditing,
  stopEditing,
}) {
  const [cellValue, setCellValue] = React.useState(initialValue || '');

  return (
    <input
      style={{
        width: '95%',
        border: '1px solid #ccc',
        padding: '4px',
        borderRadius: '4px',
      }}
      value={cellValue}
      onFocus={startEditing}
      onChange={(e) => setCellValue(e.target.value)}
      onBlur={() => {
        updateCell(rowKey, colKey, cellValue);
      }}
    />
  );
}

export function TableEditor({
  data = {},
  onChange,
  startEditing,
  stopEditing,
}) {
  // Handle null/undefined data
  const safeData = data || {};

  const headers =
    Object.keys(safeData).length > 0 && safeData[Object.keys(safeData)[0]]
      ? Object.keys(safeData[Object.keys(safeData)[0]])
      : [];

  const updateCell = (rowKey, colKey, value) => {
    console.log('updateCell', rowKey, colKey, value);
    if (safeData[rowKey]?.[colKey] === value) {
      return;
    }
    const updated = { ...safeData };
    updated[rowKey] = { ...updated[rowKey], [colKey]: value };
    onChange(updated, true);
  };

  return (
    <table
      style={{
        width: '100%',
        borderCollapse: 'collapse',
        border: 'none',
      }}
      tabIndex="0"
      onFocus={startEditing}
      onBlur={() => {
        window.onbeforeunload = undefined;
      }}
    >
      <thead>
        <tr>
          <th style={{ border: 'none' }}>Row</th>
          {headers.map((colKey) => (
            <th key={colKey} style={{ border: 'none' }}>
              {colKey}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Object.entries(safeData).map(([rowKey, rowObj]) => (
          <tr key={rowKey}>
            <th style={{ border: 'none' }}>{rowKey}</th>
            {headers.map((colKey) => (
              <td key={colKey} style={{ border: 'none' }}>
                {(() => {
                  const cellValue = rowObj[colKey];
                  const initialValue =
                    cellValue &&
                    typeof cellValue === 'object' &&
                    'Existing Value' in cellValue
                      ? cellValue['Existing Value']
                      : cellValue ?? '';
                  return (
                    <CellEditor
                      rowKey={rowKey}
                      colKey={colKey}
                      initialValue={initialValue}
                      updateCell={updateCell}
                      //   startEditing={startEditing}
                      //   stopEditing={stopEditing}
                    />
                  );
                })()}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
